/* eslint-disable */
import React from 'react'
// nodejs library to set properties for components
import PropTypes from 'prop-types'
// react components for routing our app without refresh
import Link, { navigateTo } from 'gatsby-link'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

// @material-ui/icons
import LocalAtm from '@material-ui/icons/LocalAtm'
import People from '@material-ui/icons/People'
import StoreMallDirectory from '@material-ui/icons/StoreMallDirectory'
import VpnLock from '@material-ui/icons/VpnLock'
import ImportExport from '@material-ui/icons/ImportExport'
import Call from '@material-ui/icons/Call'
import HowToReg from '@material-ui/icons/HowToReg'
import AssignmentTurnedIn from '@material-ui/icons/AssignmentTurnedIn'
import BNIcon from '../../assets/img/BNIcon.svg'

// core components
import CustomDropdown from '../CustomDropdown/CustomDropdown.jsx'
import Button from '../CustomButtons/Button.jsx'

import headerLinksStyle from '../../assets/jss/material-kit-pro-react/components/headerLinksStyle.jsx'

function HeaderLinks({ ...props }) {
  const { classes, dropdownHoverColor } = props
  return (
    <List className={classes.list + ' ' + classes.mlAuto}>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          navDropdown
          hoverColor={dropdownHoverColor}
          buttonText="About Us"
          buttonProps={{
            className: classes.navLink,
            color: 'transparent',
          }}
          dropdownList={[
            <Link to="/whoweare" className={classes.dropdownLink}>
              <People className={classes.dropdownIcons} /> Who We Are
            </Link>,
            <Link to="/contact" className={classes.dropdownLink}>
              <Call className={classes.dropdownIcons} />
              Contact
            </Link>,
          ]}
        />
      </ListItem>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          navDropdown
          hoverColor={dropdownHoverColor}
          buttonText="Services"
          buttonProps={{
            className: classes.navLink,
            color: 'transparent',
          }}
          dropdownList={[
            <Link to="/locations#catm" className={classes.dropdownLink}>
              <LocalAtm className={classes.dropdownIcons} /> CATM
            </Link>,
            <Link to="/locations#branches" className={classes.dropdownLink}>
              <StoreMallDirectory className={classes.dropdownIcons} /> Branches
            </Link>,
            <OutboundLink
              href="https://exchange.bitnational.com/?login=true"
              className={classes.dropdownLink}
            >
              <ImportExport className={classes.dropdownIcons} /> Exchange
            </OutboundLink>,
          ]}
        />
      </ListItem>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          navDropdown
          hoverColor={dropdownHoverColor}
          buttonText="Docs"
          buttonProps={{
            className: classes.navLink,
            color: 'transparent',
          }}
          dropdownList={[
            <Link to="/privacy-policy" className={classes.dropdownLink}>
              <VpnLock className={classes.dropdownIcons} /> Privacy Policy
            </Link>,
            <Link to="/terms-of-use" className={classes.dropdownLink}>
              <HowToReg className={classes.dropdownIcons} />
              Terms of Use
            </Link>,
            <Link to="/kyc-policy" className={classes.dropdownLink}>
              <AssignmentTurnedIn className={classes.dropdownIcons} />
              KYC Policy
            </Link>,
            <Link to="/aml-policy" className={classes.dropdownLink}>
              <AssignmentTurnedIn className={classes.dropdownIcons} />
              AML Policy
            </Link>,
          ]}
        />
      </ListItem>
      <ListItem className={classes.listItem}>
        <Link className={classes.listItem} to="/publications">
          <Button
            color={'transparent'}
            target="_blank"
            className={classes.navLink + ' ' + classes.whiteHover}
          >
            Publications
          </Button>
        </Link>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          href="https://exchange.bitnational.com/?login=true"
          color={'transparent'}
          target="_blank"
          round
          className={
            classes.navLink + ' ' + classes.loginLink + ' ' + classes.whiteHover
          }
        >
          login
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          href="https://exchange.bitnational.com/?register=true"
          color={'info'}
          target="_blank"
          size="sm"
          style={{ marginLeft: 15 }}
          className={classes.navButton}
          round
        >
          sign up
        </Button>
      </ListItem>
    </List>
  )
}

HeaderLinks.defaultProps = {
  hoverColor: 'primary',
}

HeaderLinks.propTypes = {
  dropdownHoverColor: PropTypes.oneOf([
    'dark',
    'primary',
    'info',
    'success',
    'warning',
    'danger',
    'rose',
  ]),
}

export default withStyles(headerLinksStyle)(HeaderLinks)



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx